import { Component, OnInit } from '@angular/core';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { ConsultaConvenioService } from 'src/app/services/consulta-convenio/consulta-convenio.service';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { ConvenioAbonoService } from 'src/app/services/convenio-abono/convenio-abono.service';
import { ConsultaPrestamosService } from 'src/app/services/consulta-prestamos/consulta-prestamos.service';
import { DialogEditConvenioEjecutivo } from '../convenio/convenio-validar-ejecutivo.component';
import { DialogEditPrestamoEjecutivo } from 'src/app/components/prestamos/prestamos-confirmar.component';
import { ModalInfoRechazoBeneficiario } from '../common/modal-info-rechazo-beneficiario.component';
import { NgForm } from '@angular/forms';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';


export interface DialogData {
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare const Rut: any;

@Component({
    selector: 'app-codeudores',
    templateUrl: '../../pages/mantenedor-codeudores/codeudores.component.html',
    styleUrls: ['../../pages/mantenedor-codeudores/codeudores.component.css']
})
export class CodeudoresComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    cuotas: any
    idUsuario: string = localStorage.getItem("idUsuario")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    currentDate: any
    botonActivo: any = true
    idEjecutivo = localStorage.getItem("idUsuario")
    allComplete: boolean = false
    afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
    afiliadoCuota: any
    postulaciones: any
    tiposProd: any
    tipos: any
    productos: any
    regiones: any
    proveedores: any
    totalMaximo: any
    categorias: any
    tipoPostulacion: string = "Disponibles"
    solicitud = "convenio";

    buscador: any =
        {
            selectConvenio: 0,
            tipos: '0',
            rut: '', rut2: '', rutAfiliado: '', region: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
            estado: ['APROBADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
        }
    tiposProductos: any[] = [
        { id: 4, descripcion: 'PRESTAMO' },
        { id: 5, descripcion: 'CONVENIO' },

    ];
    constructor(private afiliacionService: AfiliacionService,
        public consultaConvenioService: ConsultaConvenioService,
        public convenioAbonoService: ConvenioAbonoService,
        public consultaPrestamosService: ConsultaPrestamosService,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        let vm = this
        this.currentDate = new Date(Date.now()).getTime();
        this.buscador.estado = this.buscador.estadoselect;



        this.loadData()
    }

    loadData() {
        let vm = this
        this.tiposProd = this.tiposProductos;
        if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {

            vm.afiliado.rut = localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");
            vm.afiliado.nombreAfiliado = localStorage.getItem("nombreUsuario");
            vm.afiliado.idAfiliado = localStorage.getItem("idUsuario");
        }

    }

    buscaAfiliado(rutABuscar: any) {
        let vm = this
        if (Rut(rutABuscar)) {
            let rut = rutABuscar.split('.').join('').split('-')[0]
            vm.config.currentPage = 1
            vm.config.totalItems = 0
            vm.config.itemsPerPage = 5
            vm.config.indexInicial = 0
            vm.buscador.currentPage = 1
            vm.buscador.itemsPerPage = 5
            vm.postulaciones = []
            this.traePostulantes(rut);

        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
    }

    traePostulantes(rut: any) {
        let vm = this

        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        this.convenioAbonoService.traePostulantes(rut).then
            (
                (usuario: Usuario) => {

                    vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
                    vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
                    vm.afiliado.idAfiliado = usuario.id
                    vm.cargaSolicitudesCodeudor(vm.afiliado.idAfiliado, vm.buscador.tipos);
                    Swal.close();

                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
            })
    }
    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    // salir() { this.router.navigate(['/index']) }



    cargaSolicitudesCodeudor(idUsuario: any, tipo: any) {
        let vm = this;
        vm.postulaciones = []
        vm.tipoPostulacion = "Disponibles"
        vm.solicitud = 'codeudor'
        vm.consultaConvenioService.postulacionesMantenedorCodeudor(vm.afiliado.idAfiliado, this.buscador, tipo).then(
            (prestamos: any) => {
                vm.postulaciones = prestamos.resultado


                vm.postulaciones = prestamos.resultado
                vm.buscador.paginasTotal = prestamos.resultado.length
                vm.config.currentPage = this.buscador.currentPage
                vm.config.totalItems = prestamos.cantidadRegistros
                vm.tipoPostulacion = "Codeudor"

                console.log("config", vm.config);

            }
        )
            .catch(error => {
                console.log(error)
                Swal.close();

                vm.config.currentPage = 1
                vm.postulaciones = []
                vm.config.totalItems = 0
                this.openAlertDialog('No se pudo obtener las solicitudes de codeudor.', 'btn-danger')
            })
    }


    detalleRechazoBeneficiario(id: any) {
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();

        let data: any = {}

        this.afiliacionService.buscarPago(id).then
            (
                (postulacion: any) => {
                    data.tipoRechazo = postulacion.nombreMotivoRechazo
                    data.comentarioRechazo = postulacion.motivoRechazo
                }
            )
            .catch(error => console.log(error))
        Swal.close();
        const dialogRef = this.dialog.open(ModalInfoRechazoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe(() => { })
    }

    pageChanged(event: any, rutABuscar: any) {
        this.config.currentPage = event
        this.buscador.currentPage = event
        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
        let rut = rutABuscar.split('.').join('').split('-')[0]
        if (rut) {
            this.traePostulantes(rut);
        }
    }

    detalleBeneficiario(rutAfiliado: any) {
        let data: any = {}

        this.consultaPrestamosService.traeUsuario(rutAfiliado.split('-')[0]).then
            (
                (usu: any) => {
                    console.log(usu)

                    data.nombre = usu.nombres + usu.apellidoPaterno + usu.apellidoMaterno
                    data.telefono = usu.telefonoFijo
                    data.celular = usu.telefonoMovil
                    data.mail = usu.email
                    data.prevision = usu.prevision
                    data.beneficiarios = usu.carga
                }
            )
            .catch(error => console.log(error))

        const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe(() => { })
    }

    openEditDialogValidar(idConvenio: any, mostrarEditar?: any, disponiblePago?: any, tipoProducto?: any) {

        if (tipoProducto == 'CONVENIO') {
            this.openDialogConvenio(idConvenio, mostrarEditar, disponiblePago)
        } else {
            this.openDialogPrestamo(idConvenio, mostrarEditar, disponiblePago)
        }
    }
    openDialogConvenio(idConvenio: any, mostrarEditar?: any, disponiblePago?: any) {

        this.consultaConvenioService.traeCategoriaConvenio().then(response => this.categorias = response).catch(error => console.log(error))
        this.consultaConvenioService.traeProveedorSelect().then(response => this.proveedores = response).catch(error => console.log(error))
        this.consultaConvenioService.traeCantidadCuotas().then(cuota => this.cuotas = cuota).catch(error => console.log(error))
        this.consultaConvenioService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))
        this.consultaConvenioService.traeMontoTotalDisponible(this.idEjecutivo).then(response => this.totalMaximo = response).catch(error => { console.log(error); this.totalMaximo = 0; });
        let vm = this
        let data: any = {}
        this.consultaConvenioService.traeConvenio(idConvenio).then(
            (response: any) => {


                {

                    data.regiones = this.regiones,
                        data.categorias = this.categorias,
                        data.totalMaximo = this.totalMaximo,
                        data.proveedores = this.proveedores,
                        data.idCodeudor = this.idUsuario,
                        data.montoSolicitado = response.montoSolicitado,
                        data.idConvenio = response.idConvenio,
                        data.idPostulacion = response.idPostulacion,
                        data.nombreUsuario = response.nombreUsuario,
                        data.rutUsuario = response.rutUsuario,
                        data.idCantidadCuota = response.idCantidadCuota,
                        data.montoCuota = response.montoCuota,
                        data.fechaIngreso = response.fechaIngreso,
                        data.fechaPrimerPago = response.fechaPrimerPago,
                        data.idTipoConvenio = response.idTipoConvenio,
                        data.idRegion = response.idRegion,
                        data.nombreCodeudorUno = response.nombreCodeudorUno,
                        data.nombreCodeudorDos = response.nombreCodeudorDos,
                        data.rutCodeudorUno = response.rutCodeudorUno,
                        data.rutCodeudorDos = response.rutCodeudorDos,
                        data.idProveedor = response.idProveedor,
                        data.idProducto = response.idProducto,
                        data.idCarga = response.idCarga,
                        data.nombreCarga = response.nombreCarga,
                        data.rutCarga = response.rutCarga,
                        data.numPresupuesto = response.numPresupuesto,
                        data.mostrarEditar = mostrarEditar,
                        data.disponiblePago = disponiblePago,
                        data.idAfiliado = response.idUsuario,
                        data.tieneConvenioAdjunto = response.tieneConvenioAdjunto,
                        this.consultaConvenioService.traeCantidadCuotasProveedor(response.idProveedor).
                            then(cuota => data.cuotas = cuota).catch(error => console.log(error))
                }

                const dialogRef = vm.dialog.open(DialogEditConvenioEjecutivo,
                    { width: '40%', data: data })
                Swal.close();
                dialogRef.afterClosed().subscribe(() => {


                })
            }
        )
            .catch(error => {
                console.log(error)
                Swal.close();
                this.openAlertDialog('No se pudo obtener la postulacion.', 'btn-danger')
            })

    }

    openDialogPrestamo(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
        let vm = this

        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let mostrarAprobarButton = true;
        let mostrarEnviarButton = true;
        if (disponiblePago) {
            mostrarAprobarButton = false;
            mostrarEnviarButton = false;

            if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
                disponiblePago = false;
                mostrarAprobarButton = true;
                mostrarEnviarButton = true;
            }

        }
        this.consultaPrestamosService.traeTipoPrestamo().then(tipo => this.tipos = tipo).catch(error => console.log(error))

        this.consultaPrestamosService.traeCantidadCuotas().then(cuota => this.cuotas = cuota).catch(error => console.log(error))

        this.consultaPrestamosService.traeMontoTotalDisponible(this.idEjecutivo).then(response => {
            this.totalMaximo = response;
        }
        ).catch(error => {
            console.log(error);
            this.totalMaximo = 0;
        });
        this.consultaPrestamosService.traePrestamoGestionar(idPostulacion, mostrarEditar).then
            (

                (response: any) => {
                    let data: any =
                    {
                        archivos: response.archivoAdjunto,
                        tipos: this.tipos,
                        cuotas: this.cuotas,
                        totalMaximo: this.totalMaximo,
                        idPrestamo: response.idPrestamo,
                        idPostulacion: response.idPostulacion,
                        nombreUsuario: response.nombreUsuario,
                        apellidoUsuario: response.apellidoUsuario,
                        idCodeudor1: response.idCodeudorUno,
                        idCodeudor2: response.idCodeudorDos,
                        rutCodeudor1: response.rutCodeudorUno,
                        rutCodeudor2: response.rutCodeudorDos,
                        nombreCodeudor1: response.nombreCodeudorUno,
                        nombreCodeudor2: response.nombreCodeudorDos,
                        apellidoCodeudor1: response.apellidoCodeudorUno,
                        apellidoCodeudor2: response.apellidoCodeudorDos,
                        rutUsuario: response.rutUsuario,
                        cantidadCuotas: response.cantidadCuota,
                        montoCuota: response.totalCuota,
                        fechaIngreso: response.fechaIngreso,
                        fechaPrimerPago: response.fechaPrimerPago,
                        montoSolicitado: response.montoSolicitado,
                        tipoPrestamo: response.tipoPrestamo,
                        deshabilitado: true,
                        presionaEditar: false,
                        idCantidadCuotas: response.idCantidadCuotas,
                        idUsuario: response.idUsuario,
                        montoTotalCuota: response.montoTotalCuota,
                        mostrarEditar: mostrarEditar,
                        disponiblePago: !disponiblePago,
                        mostrarAprobarButton: mostrarAprobarButton,
                        asientoContable: response.asientoContable,
                        estado: response.estado

                    }

                    let vm = this

                    const dialogRef = vm.dialog.open(DialogEditPrestamoEjecutivo, {
                        width: '45%', data: data
                    })
                    Swal.close();

                    dialogRef.afterClosed().subscribe(() => {
                        /* if(vm.tipoPostulacion=='Asignadas'){
                             this.cargaSolicitudesCodeudor(vm.afiliado.idAfiliado,0)
                         }else{
                             this.cargaSolicitudesCodeudor(vm.afiliado.idAfiliado,0)
                         }*/

                    })
                }
            )
            .catch(error => {
                console.log('error:', error)
                Swal.close();

            })
    }


    onDescargarArchivosClick(postulacionId: any) {
        let vm = this

        this.consultaConvenioService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL, '_blank')
                    })

                }
            )
            .catch
            (
                error => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
    }
}